module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADcSURBVGhD7dFRDoJADIRhjubNvRmrKz8GM5Q+aZs4X0JimWJ2YDGzc2OM27wYRXWeWtf1Pi9GUZ1fov1O3sK8t0UvP89TszkPj7O3UJ1fej5zbL97v4X5e7v14Wd56th+d3wL1XmKZwRxeZ5iXxC7AKMgdgEXYBTEdQW64Jgx9trimDH22uKYMfba4pjWF19KEJfnKfYFsQswCmIXcAFGQewCKfYFsQswCmIXCP+gC44ZY68tjhljry2OGWOvLY5pffGlBHF5nmJfELsAoyB2ARdgFMTfL2D2V5blAdk6AZQhtgEiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-fence/light/48.png
// module id = 2035
// module chunks = 2